module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("insert_chart")]), _vm._v("\n    Reports have moved\n  ")], 1), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_vm._v("\n    Check out our new reports with\n    "), _c('a', {
    attrs: {
      "href": "https://dashboard.appointmentguru.co",
      "target": "_blank"
    }
  }, [_vm._v("\n      AppointmentGuru Numbers\n      "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "large": "",
      "href": "https://dashboard.appointmentguru.co",
      "target": "_blank",
      "color": "primary"
    }
  }, [_vm._v("\n      Open the Dashboard\n      "), _c('v-icon', {
    staticClass: "ml-2"
  }, [_vm._v("open_in_new")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38810d45","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Reports.vue
// module id = 1391
// module chunks = 9